function update(el: HTMLElement, reduceMotion?: boolean) {
  const scrollDriver = el;
  const scrollLeft = scrollDriver.scrollLeft;
  const itemWidth = scrollDriver.clientWidth;

  const textItems = document.querySelectorAll("[data-text]");
  const counters = document.querySelectorAll("[data-count]");
  const indicators = document.querySelectorAll("[data-indicator]");
  const imageGroups = document.querySelectorAll("[data-image-group]");

  const totalRealSlides = textItems.length;

  // Progress now includes virtual slides (0 = virtual first, 1 = real first, etc.)
  const progress = scrollLeft / itemWidth;
  const activeIndex = Math.round(progress);
  const activeSlideProgress = progress % 1;
  const realActiveIndex = virtualToRealIndex(activeIndex, totalRealSlides);

  // Helper to update a text item's appearance
  const updateTextItem = (
    item: Element,
    index: number,
    _relativeIndex?: number,
  ) => {
    if (!isHTMLElement(item)) return;

    const virtualIndex = index + 1;
    const relativeIndex = _relativeIndex ?? progress - virtualIndex;
    const isVisible = Math.abs(relativeIndex) < 1.5;
    const slideProgress = Math.max(0, 1 - Math.abs(relativeIndex));

    const subtitle = item.querySelector("p");
    if (!subtitle) return;

    imageGroups.forEach((el) => {
      updateImage(el.childNodes[index], slideProgress, isVisible, reduceMotion);
    });
    // imageGroups[index].childNodes.forEach((node) => {
    //   updateImage(node, slideProgress, isVisible);
    // });
    // updateImageGroup(imageGroups[index], slideProgress, isVisible);
    updateCounter(counters[index], slideProgress, isVisible);
    updateSlide(item, slideProgress, isVisible);
    updateIndicator(indicators[index], index, realActiveIndex, isVisible);
  };

  textItems.forEach((item, realIndex) => {
    // Normal update for the item's real position
    updateTextItem(item, realIndex);

    // Check if this item should also appear as a "ghost" at the boundaries
    const isFirst = realIndex === 0;
    const isLast = realIndex === totalRealSlides - 1;

    if (isLast && progress < 1.5) {
      // Handle wrapping: last item appears at virtual position 0
      const ghostRelativeIndex = progress - 0; // Virtual slide 0
      updateTextItem(item, realIndex, ghostRelativeIndex);
    } else if (isFirst && progress > totalRealSlides - 0.5) {
      // Handle wrapping: first item appears at virtual position (totalRealSlides + 1)
      const ghostRelativeIndex = progress - (totalRealSlides + 1);
      updateTextItem(item, realIndex, ghostRelativeIndex);
    }
  });

  return {
    distance: Math.round(scrollLeft),
    progress,
    activeSlideProgress,
    activeIndex: realActiveIndex,
  };
}

export { update };

// ------------------------------------------------------
// UTILS
// ------------------------------------------------------

function virtualToRealIndex(virtualIndex: number, total: number) {
  if (virtualIndex <= 0) return total - 1; // Virtual first → show last content
  if (virtualIndex >= total + 1) return 0; // Virtual last → show first content
  return virtualIndex - 1; // Offset by 1 for the prepended virtual slide
}

function updateCounter(
  counter: Element,
  slideProgress: number,
  isVisible: boolean,
) {
  if (!isHTMLElement(counter)) return;

  const opacity = Math.pow(slideProgress, 2);
  const blur = (1 - slideProgress) * 4;

  if (isVisible) {
    counter.style.display = "block";
    counter.style.opacity = opacity.toString();
    counter.style.filter = `blur(${blur}px)`;
  } else {
    counter.style.display = "none";
  }
}

function updateImage(
  image: ChildNode,
  slideProgress: number,
  isVisible: boolean,
  reduceMotion?: boolean,
) {
  if (!isHTMLElement(image)) return;

  const opacity = Math.pow(slideProgress, 2);
  const scale = reduceMotion ? 1 : 1 + slideProgress * 0.1;

  if (isVisible) {
    image.style.display = "block";
    image.style.opacity = opacity.toString();
    if (!reduceMotion) image.style.scale = scale.toString();
  } else {
    image.style.display = "none";
  }
}

function updateSlide(
  slide: Element,
  slideProgress: number,
  isVisible: boolean,
) {
  if (!isHTMLElement(slide)) return;

  const opacity = Math.pow(slideProgress, 2);
  const blur = (1 - slideProgress) * 4;
  const scale = 1 - (1 - slideProgress) * 0.1;

  if (isVisible) {
    slide.style.display = "grid";
    slide.style.opacity = opacity.toString();
    slide.style.scale = scale.toString();
    slide.style.filter = `blur(${blur}px)`;
  } else {
    slide.style.display = "none";
  }
}

function updateIndicator(
  indicator: Element,
  index: number,
  activeIndex: number,
  isVisible: boolean,
) {
  if (!isHTMLElement(indicator)) return;
  if (isVisible) {
    indicator.dataset.active = index === activeIndex ? "true" : "false";
  } else {
    if (indicator instanceof HTMLElement) indicator.dataset.active = "false";
  }
}

function isHTMLElement(el: unknown) {
  return el instanceof HTMLElement;
}
